import { Components, Theme } from '@mui/material/styles'

import Card from './Card'

export default function componentsOverrides(theme: Theme): Components {
   return {
      ...Card(theme),
   }
}
